"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentTable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../../../common");
const option_1 = require("../../../../../common/option");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const classes_1 = require("../../../../base/classes");
const popup_1 = require("../../../../base/popup");
const action_1 = require("../../../../menu/action");
const funtions_1 = require("../../../DSTT001/funtions");
const constant_1 = require("../../constant");
const function_1 = require("../../function");
const AssignmentItem_1 = require("./AssignmentItem");
const AssignmentTitle_1 = require("./AssignmentTitle");
const DeleteListBtn_1 = require("./DeleteListBtn");
const DSTL001ListStyled_1 = require("./DSTL001ListStyled");
const functions_1 = require("./functions");
exports.AssignmentTable = react_1.default.memo(({ isTeacher = false, isTest = false, isSurvey = false, isReserve = false, isBackOffice = false, isReserveRegist = false, isHome = false, defaultCheckList = [], setUpdateCheckList, selectItem, handlerSelectItem, conference_id, }) => {
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const classes_data = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClasses)(state));
    const { isDesktop, isTablet, isMobile, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const listPageName = isSurvey
        ? 'surveyListPage'
        : isTest
            ? 'testListPage'
            : 'assignmentListPage';
    const [previousPageState, setPreviousPageState] = (0, react_1.useState)(); // 이전 페이지의 상태를 저장
    const [initLoad, setInitLoad] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(isHome ? 5 : 10);
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    // 과제 진행 상태
    const [status, setStatus] = (0, react_1.useState)('select');
    // 출제 유형
    const [type, setType] = (0, react_1.useState)('select');
    // Keyword 검색어
    const [keyword, setKeyword] = (0, react_1.useState)('');
    const { data, refetch } = (0, server_1.useAssignmentList)({
        ...(isReserve
            ? isReserveRegist
                ? { conference_id: '' }
                : { conference_id: ['', conference_id] }
            : {}),
        // 설문조사 목록은 assignment 필터를 걸지 않는다(survey:true 만으로 조회).
        // → 출제유형 '설문조사'로 만든 테스트(assignment:false, survey:true)도 함께 노출.
        ...(isSurvey ? {} : { assignment: !isTest }),
        offset: page === 0 ? 0 : page * count,
        limit: count,
        orderby: isSurvey
            ? ['creation_time DESC']
            : isBackOffice
                ? ['creation_time DESC']
                : isTest
                    ? [
                        'status DESC',
                        'creation_time DESC',
                        'abs(timestampdiff(minute,now(),startline))',
                    ]
                    : ['status DESC', 'abs(timestampdiff(minute,now(),startline))'],
        ...(isHome && !isTest
            ? { status: [constant_1.TEST_STATUS.OPEN, constant_1.TEST_STATUS.CREATED] }
            : isReserve
                ? isBackOffice
                    ? {}
                    : { status: constant_1.TEST_STATUS.CREATED }
                : {}),
        ...(isBackOffice ? { back_office: true } : { class_id: classesId }),
        ...(status !== 'select' ? { status } : {}),
        // 설계안 갖고오기/기존 테스트 불러오기(isBackOffice·isReserve 팝업)에서는 survey 필터를 걸지 않는다.
        // → 출제유형 '설문조사'(survey:true) 항목도 목록에 노출(결과 표시는 survey면 '설문조사'로).
        ...(!isBackOffice && !isReserve ? { survey: isSurvey } : {}),
        ...(isBackOffice && isSurvey
            ? { type: t('assignment.survey') }
            : isSurvey
                ? {}
                : type !== 'select'
                    ? { type: t(`assignment.${type}`) }
                    : {}),
        ...(keyword ? { keyword } : {}),
        ...(isBackOffice && isReserve ? { status: 'created' } : {})
    });
    // (리스트 갱신
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        return (0, functions_1.getAssignmentTableProps)(isTest, isSurvey, isHome, isReserve, isTeacher, isBackOffice, isMobile, isTablet);
    }, [isTest, isSurvey, isHome, isReserve, isTeacher, isBackOffice, isMobile, isTablet]);
    (0, react_1.useEffect)(() => {
        const initializeState = () => {
            const previousPage = historyStore.getRecentPageHistory(listPageName);
            const searchOptions = previousPage?.searchOption;
            if (searchOptions) {
                for (const key in searchOptions) {
                    switch (key) {
                        case 'keyword':
                            setKeyword(searchOptions[key]);
                            break;
                        case 'status':
                            setStatus(searchOptions[key]);
                            break;
                        case 'type':
                            setType(searchOptions[key]);
                            break;
                    }
                }
            }
            setCheckList([]);
            setPage(previousPage?.prePage || 0);
            setInitLoad(true);
        };
        initializeState();
        return () => {
            setInitLoad(false);
            setStatus('select');
            setType('select');
        };
    }, [isTest, isSurvey, listPageName]);
    // 이벤트 등록 - 리스트 갱신
    (0, react_1.useEffect)(() => {
        const delSuccessList = (list) => {
            setCheckList(prev => prev.filter(id => !list.includes(id)));
        };
        APP.eventManager.subscribe('DEL_SUCCESS_LIST', delSuccessList);
        return () => {
            APP.eventManager.unsubscribe('DEL_SUCCESS_LIST', delSuccessList);
        };
    }, []);
    // 이벤트 등록 - 리스트 갱신
    (0, react_1.useEffect)(() => {
        const updateOptions = (option) => {
            if (option.status !== undefined) {
                setStatus(option.status);
            }
            if (option.type !== undefined) {
                setType(option.type);
            }
            if (option.keyword !== undefined) {
                setKeyword(option.keyword);
            }
        };
        if (isBackOffice) {
            APP.eventManager.subscribe('UPDATE_SEARCH_OPTION', updateOptions);
        }
        return () => {
            APP.eventManager.unsubscribe('UPDATE_SEARCH_OPTION', updateOptions);
        };
    }, [isBackOffice]);
    // 과제/테스트 이동 시 체크리스트 초기화
    (0, react_1.useEffect)(() => {
        if (isBackOffice)
            return;
        APP.eventManager.publish('UPDATE_TABLE_ITEM', { className: 'task-list-001' });
    }, [testData]);
    // 이벤트 등록 - 리스트 갱신
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe(constant_1.REFRESH_ASSIGNMENT_LIST, refetchList);
        return () => {
            APP.eventManager.unsubscribe(constant_1.REFRESH_ASSIGNMENT_LIST, refetchList);
        };
    }, []);
    //홈화면 리스트 갱신
    (0, react_1.useEffect)(() => {
        APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
    }, [classes_data?.id]);
    (0, react_1.useEffect)(() => {
        if (data) {
            //이전 페이지 저장된 기록 초기화
            const { total_count, found_count, items } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
                return;
            }
            //이전 페이지 저장된 기록 초기화
            if (previousPageState) {
                setPreviousPageState(undefined);
            }
            setTotalCount(isHome ? Math.min(total_count, 5) : total_count);
            if (total_count > 0) {
                // @ts-ignore
                const list = items.map(i => ({ ...i }));
                if (checkList.length > 0 && isReserve) {
                    setTestData(prevTestData => {
                        const prevDataById = lodash_1.default.keyBy(prevTestData, 'id');
                        const newDataById = lodash_1.default.keyBy(list, 'id');
                        const mergedData = lodash_1.default.merge({}, prevDataById, newDataById);
                        const allItems = lodash_1.default.values(mergedData);
                        const checkedItems = allItems.filter(item => checkList.includes(item.id));
                        const notCheckedItems = allItems.filter(item => !checkList.includes(item.id));
                        return [...checkedItems, ...notCheckedItems];
                    });
                }
                else {
                    if (isReserve) {
                        setTestData(prevTestData => {
                            // prevTestData에서 list에 포함된 id만 필터링
                            const filteredPrevData = prevTestData.filter(item => !list.some(newItem => newItem.id === item.id));
                            const prevDataById = lodash_1.default.keyBy(filteredPrevData, 'id');
                            const newDataById = lodash_1.default.keyBy(list, 'id');
                            // 병합된 데이터 생성
                            const mergedData = lodash_1.default.merge({}, prevDataById, newDataById);
                            // 최종 배열 반환
                            return lodash_1.default.values(mergedData);
                        });
                    }
                    else {
                        if (!lodash_1.default.isEqual(testData, list))
                            setTestData(list);
                    }
                }
                return;
            }
            // setTestData(items);
            if (handlerSelectItem && total_count >= 1) {
                handlerSelectItem(items[0].id, items[0].title);
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    (0, react_1.useEffect)(() => {
        setCount(isHome ? 5 : 10);
        refetchList();
    }, [isHome, isTest, isSurvey, count, page, status, type, keyword]);
    (0, react_1.useEffect)(() => {
        return () => {
            setKeyword('');
        };
    }, [isTest, isSurvey]);
    // 상세 페이지로 이동
    const goToDetailPage = (id, initialBigTab) => {
        // 새로운 페이지로 이동할 때 현재 상태를 기록
        const historyItem = {
            preItems: {},
            props: {
                isHome: isHome,
                isTest: isTest,
                isReserve: isReserve,
                isReserveRegist: isReserveRegist,
                conference_id: conference_id,
            },
            prePage: page,
            searchOption: {
                keyword,
                status,
                type,
            },
            pageName: listPageName,
        };
        historyStore.pushHistory(historyItem);
        dispatch((0, action_1.updateMenu)(isSurvey ? 'learningSupportRoom' : isTeacher ? 'learningManagement' : 'myRoom', {
            menu: isSurvey ? 'survey' : isTest ? 'test' : 'assignment',
            detail: 'detail',
        }, id, initialBigTab ? { initialBigTab } : undefined));
    };
    // 수정 페이지로 이동
    const handlerEdit = (id) => {
        // 새로운 페이지로 이동할 때 현재 상태를 기록
        const historyItem = {
            preItems: {},
            props: {
                isHome: isHome,
                isTest: isTest,
                isReserve: isReserve,
                isReserveRegist: isReserveRegist,
                conference_id: conference_id,
            },
            prePage: page,
            searchOption: {
                keyword,
                status,
                type,
            },
            pageName: listPageName,
        };
        historyStore.pushHistory(historyItem);
        if (isBackOffice) {
            APP.eventManager.publish('CHANGE_MENU', {
                showDepth: 'modify',
                props: { id },
            });
        }
        else {
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'modify',
                id: id,
                props: {
                    isBackOffice,
                },
            });
        }
    };
    const renderTitle = (0, react_1.useMemo)(() => initLoad && !isBackOffice && (react_1.default.createElement(AssignmentTitle_1.AssignmentTitle, { isBackOffice: isBackOffice, isTest: isTest, isSurvey: isSurvey, isTeacher: isTeacher, checkList: checkList, status: status, type: type, keyword: keyword, setStatus: setStatus, setType: setType, setKeyword: setKeyword })), [isTest, isSurvey, isBackOffice, initLoad, isTeacher, status, type, keyword, checkList]);
    // list 페이지 업데이트 시
    const handlerMoreData = (page) => {
        if (isReserve) {
            setPage(prevPage => prevPage + 1);
        }
        else {
            setPage(page);
        }
    };
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    const submitAssignment = () => {
        if (checkList.length > 1) {
            alert('테스트 등록은 하나만 가능합니다.');
            return;
        }
        setUpdateCheckList && setUpdateCheckList(checkList);
        closePopup();
    };
    // 홈 대시보드에서 "진행중(open)·미응시" 테스트를 학생이 클릭하면 상세(문항 나열/성적표)
    // 대신 모의고사모드 강의실로 입장시킨다. (학생 테스트 목록 AssignmentTableStudents의
    // 'conference' 액션과 동일 동작) 그 외(교사/관리자, 비-open, 응시완료, conference_id 부재,
    // 과제·설문)는 false → 기존 상세 이동 유지.
    const shouldEnterConference = (item) => {
        if (!isHome || !isTest || isSurvey || isTeacher || isBackOffice || isReserve)
            return false;
        if (item.submitted === true)
            return false;
        if (!item.conference_id)
            return false;
        // 서버 status가 현재 시각과 어긋날 수 있어 시작/마감일 기준으로 재계산
        const actualStatus = (0, function_1.calculateActualStatus)(item);
        const isEnterable = item.enterable === true;
        // 진행중(open) 이거나 입장창(enterable)이면서 강제 종료(closed)가 아닐 때만 입장
        return (actualStatus !== constant_1.TEST_STATUS.CLOSED &&
            (actualStatus === constant_1.TEST_STATUS.OPEN || isEnterable));
    };
    const renderItem = (item, styles) => {
        if (!item)
            return;
        const isTeacherTestListView = isTeacher && isTest && !isHome && !isReserve && !isBackOffice && !isMobile;
        return tableReadDataKeys.map(headItem => {
            const isClickableCell = isTeacherTestListView
                ? ['test_name', 'grade_report'].includes(headItem.title)
                : !(isReserve ||
                    headItem.title === 'etc' ||
                    headItem.title === 'manage' ||
                    isBackOffice);
            return (react_1.default.createElement("div", { key: headItem.title, className: `body-item ${headItem.title}`, style: {
                    flex: !isMobile && headItem.space,
                    ...styles?.bodyItem,
                    overflow: 'hidden',
                    cursor: !isClickableCell ? 'default' : 'pointer',
                    ...(isMobile &&
                        isTeacher &&
                        headItem.title === 'etc' && {
                        position: 'absolute',
                        top: '12px',
                        right: isHome ? '10px' : '0',
                        flex: 1,
                        width: 'calc(100% - 28px)',
                    }),
                    ...(headItem.title !== 'etc' && {
                        width: isMobile && headItem.title === 'title' ? '80%' : '100%',
                    }),
                }, onClick: isClickableCell
                    ? e => {
                        e.preventDefault();
                        // 홈 진행중·미응시 테스트(학생)는 강의실 입장, 그 외는 기존 상세 이동
                        if (shouldEnterConference(item)) {
                            (0, funtions_1.goToConference)(item.conference_id);
                            return;
                        }
                        goToDetailPage(item.id, 
                        // 설문 상세의 탭 집합은 surveyResult/submitResult — 'testResult' 를
                        // 넘기면 상세에서 활성 탭 표시가 안 됨(보정 로직 있으나 소스도 정합 유지)
                        headItem.title === 'grade_report'
                            ? 'gradeData'
                            : isSurvey
                                ? 'surveyResult'
                                : 'testResult');
                    }
                    : undefined },
                react_1.default.createElement(AssignmentItem_1.AssignmentItem, { headItem: headItem, item: item, isHome: isHome, isTest: isTest, isMobile: isMobile, isTablet: isTablet, isTeacher: isTeacher, isBackOffice: isBackOffice, isSurvey: isSurvey, styles: styles, handlerEdit: handlerEdit, handlerGradeReport: () => goToDetailPage(item.id, 'gradeData') })));
        });
    };
    const renderEmpty = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(option_1.EmptyTable, { title: `assignment.${isSurvey ? 'survey' : isTest ? 'test' : 'assignment'}emptyData` })
        // <div className="empty_data" style={{ color: Colors.light_grey }}>
        // 	{t(`assignment.${isTest ? 'test' : 'assignment'}emptyData`)}
        // </div>
        );
    }, [isSurvey, isTest]);
    const renderGuidItem = (0, react_1.useMemo)(() => !isReserve && (react_1.default.createElement(DeleteListBtn_1.DeleteListBtn, { isTest: isTest, isOneDel: false, deleteList: checkList })), [checkList, isTest, isReserve]);
    return (react_1.default.createElement(DSTL001ListStyled_1.Container002Styled, { id: "assignment-table", className: `task-board-container assignment-table ${isHome && 'home'} ${isReserve && isTest && 'liveRoom'}`, "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$isHome": isHome, "$isTeacher": isTeacher, "$isTest": isTest, "$isReserve": isReserve, "$isBackOffice": isBackOffice },
        react_1.default.createElement(common_1.Table, { className: isHome ? 'home-list-003' : isReserve ? 'popup-list-006' : 'task-list-001', showCheckBox: !isHome && (isTeacher || isReserve) ? true : false, pagingCount: isMobile ? 5 : isTablet ? 7 : 10, showIndex: isHome ? false : isMobile ? false : true, indexOrder: "desc", isInfinite: isReserve ? true : false, data: testData, defaultCheckList: defaultCheckList, totalCount: totalCount, page: page, showCount: count, sortDefault: "id", headTitleList: headTitleList, renderTitle: !isReserve && !isHome && renderTitle, renderGuidItem: isTeacher && isMobile && !isHome && renderGuidItem, renderEmpty: totalCount <= 0 && renderEmpty, renderItem: renderItem, handlerMoreData: handlerMoreData, handlerCheckList: setCheckList, forceShowheader: !isTeacher && isMobile ? false : true, selectedId: selectItem, padding: isReserve ? false : !isHome }),
        isReserve && (react_1.default.createElement("div", { className: "btn-container", style: { margin: 0 } },
            react_1.default.createElement(common_1.Button, { text: "common.cancel", className: "btn_white xmd", onClick: closePopup }),
            react_1.default.createElement(common_1.Button, { text: "common.okay", className: "btn_default xmd", onClick: submitAssignment })))));
});
